export default __webpack_public_path__ + "static/media/select-hour-icon-disabled.b8cb3d9d.svg";